import { Gateway } from '@bolteu/react-api-gateway/es';

export interface DeviceInformation {
  device_uid: string;
  device_name: string;
  device_os_version: string;
}

interface AuthenticateRequestBody extends DeviceInformation {
  username: string;
  password: string;
}

export interface AuthenticateResponse {
  refresh_token: string;
}
export interface RefreshTokenRequest {
  refresh_token: string;
}
export interface GetAccessTokenResponse {
  access_token: string;
  expires_timestamp: number;
  expires_in_seconds: number;
  next_update_in_seconds: number;
  next_update_give_up_timestamp: number;
}

export interface AuthenticateWithMagicLinkRequest extends DeviceInformation {
  token: string;
}

export interface AuthenticateWithMagicLinkResponse {
  refresh_token: string;
}

export interface DeliveryAppLocale {
  /**
   * Five characters locale code in the form of ll-CC.
   */
  locale: string;
  /**
   * Readable locale name.
   */
  name: string;

  zd_locale: string;
}

export interface RequestResetPasswordRequest {
  username: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export class DeliveryProviderNoAuthApi extends Gateway {
  public async authenticate(request: AuthenticateRequestBody): Promise<AuthenticateResponse> {
    return this.postJSON<AuthenticateRequestBody, AuthenticateResponse>(
      `/deliveryProviderPortal/public/authenticate`,
      request,
    );
  }

  public getAccessToken(refreshToken: string): Promise<GetAccessTokenResponse> {
    return this.postJSON<RefreshTokenRequest, GetAccessTokenResponse>(
      `/deliveryProviderPortal/public/getAccessToken`,
      {
        refresh_token: refreshToken,
      },
    );
  }

  public requestPasswordReset(username: string): Promise<void> {
    return this.postJSON<RequestResetPasswordRequest, void>(
      `/deliveryProviderPortal/public/requestResetPassword`,
      {
        username,
      },
    );
  }

  public passwordReset(request: ResetPasswordRequest): Promise<void> {
    return this.postJSON<ResetPasswordRequest, void>(
      `/deliveryProviderPortal/public/resetPassword`,
      request,
    );
  }

  public async authenticateWithMagicLink(
    request: AuthenticateWithMagicLinkRequest,
  ): Promise<AuthenticateWithMagicLinkResponse> {
    return this.postJSON<AuthenticateWithMagicLinkRequest, AuthenticateWithMagicLinkResponse>(
      `/deliveryProviderPortal/public/authenticateWithMagicLink`,
      request,
    );
  }
}
